export default __webpack_public_path__ + "4c13b1f.png";